import { useSuspenseQuery } from "@apollo/client";
import {
    BusinessCode,
    LatestGeneralTermsDocument,
    LatestGeneralTermsQuery,
    LatestGeneralTermsQueryVariables,
    TermMarket,
} from "generated/graphql";

export const useLatestGeneralTermsSuspenseQuery = () => {
    const { data } = useSuspenseQuery<
        LatestGeneralTermsQuery,
        LatestGeneralTermsQueryVariables
    >(LatestGeneralTermsDocument, {
        variables: {
            businessCode: process.env.NEXT_PUBLIC_BUSINESS_CODE as BusinessCode,
            market: process.env.NEXT_PUBLIC_MARKET_CODE as TermMarket,
        },
        context: {
            fetchOptions: { next: { revalidate: 900 } },
            includeCookie: false,
        },
    });

    return data.latestTerm;
};
